import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useLazyGetSingleMediaQuery } from '@/features/media/api'
import { MediaSizes } from '@/features/media/types'
import { useMediaImage } from '@/features/media/useMediaImage'
import type { SearchResultItem } from '@/features/search/types'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { getMediaDetailsState, setMediaDetailsState } from '../slice'

const EMPTY_ITEM = {} as SearchResultItem

export const useGetSingleMedia = () => {
  const dispatch = useAppDispatch()
  const { id } = useParams<{ id: string }>()
  const { searchResultItem } =
    useAppSelector(getMediaDetailsState).mediaDetailsState

  const [getSingleMedia, request] = useLazyGetSingleMediaQuery()
  const { url } = useMediaImage(
    searchResultItem ?? EMPTY_ITEM,
    MediaSizes.Medium,
    !!searchResultItem,
  )

  useEffect(() => {
    if (!searchResultItem && id) {
      getSingleMedia(id)
    }
  }, [searchResultItem, id])

  useEffect(() => {
    if (request.isSuccess && request.data) {
      dispatch(setMediaDetailsState({ searchResultItem: request.data }))
    }
  }, [request.isSuccess, request.data])

  return { searchResultItem, url, request }
}
